import { ADD_TO_CART, ADD_TO_CART_BULK, GET_ALL_CART_DATA } from "./actionTypes";
import toast from "react-hot-toast";
import { del, get, post, put } from "../../_services/apiService";
import { API_URL } from "../../_services/apiUrl";
import { decryptData } from "../../_services/encDnc";
import { getGuestId } from "../../utils/guestUtils";

const getResolvedGuestId = async () => {
    const { int, raw } = await getGuestId();
    return { int, raw };
};

const getNormalizedCartList = (response) => {
    if (Array.isArray(response)) return response;
    if (Array.isArray(response?.data)) return response.data;
    if (Array.isArray(response?.data?.data)) return response.data.data;
    if (response?.data && typeof response.data === "object") return [response.data];
    if (response && typeof response === "object" && response.id && response.product_id) return [response];
    return [];
};

// export const get_cart_Data = () => async (dispatch) => {
//     const isLoggedIn = localStorage.getItem('isLoggedIn');

//     if (isLoggedIn) {
//         try {
//             const response = await get(`${API_URL.cart}?pisLoggedIn=${isLoggedIn}`);

//             if (response.isSuccess === 200) {
//                 dispatch({ type: GET_ALL_CART_DATA, payload: response.data });
//             } else {
//                 dispatch({ type: GET_ALL_CART_DATA, payload: [] });
//             }
//         } catch (error) {
//             dispatch({ type: GET_ALL_CART_DATA, payload: [] });
//         }
//     } else {
//         const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
//         dispatch({ type: GET_ALL_CART_DATA, payload: localCartData });
//     }
// };

export const get_cart_Data = (ipAddressOverride = "") => async (dispatch) => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');

    try {
        const { int: guestIdInt, raw: guestIp } = await getResolvedGuestId();
        const ipAddress = ipAddressOverride || guestIp;

        if (isLoggedIn) {
            const response = await post(API_URL.cart, {
                ip_address: ipAddress,
            });
            const cartList = getNormalizedCartList(response);

            if (response?.isSuccess === 200 || response?.status === true || cartList.length > 0) {
                dispatch({
                    type: GET_ALL_CART_DATA,
                    payload: Array.isArray(cartList) ? cartList : [],
                });
            } else {
                dispatch({ type: GET_ALL_CART_DATA, payload: [] });
            }
        } else {
            const response = await post(API_URL.cart, {
                guest_id: guestIdInt,
                ip_address: ipAddress,
            });
            const cartList = getNormalizedCartList(response);

            if (response?.status === true || response?.status === 1 || cartList.length > 0) {
                dispatch({
                    type: GET_ALL_CART_DATA,
                    payload: Array.isArray(cartList) ? cartList : [],
                });
            } else {
                dispatch({ type: GET_ALL_CART_DATA, payload: [] });
            }
        }
    } catch (error) {
        dispatch({ type: GET_ALL_CART_DATA, payload: [] });
    }
};

const GetProductDetailById = async (productId) => {

    try {
        const response = await get(API_URL.GetProductDetailById, {
            pProductDetailId: productId
        });

        if (response.isSuccess === 200) {
            const encryptedData = response.data;
            const result = decryptData(encryptedData);

            if (result) {
                return result[0];
            } else {
                throw new Error("Product not found");
            }
        } else {
            toast.error(response.message || 'Login failed. Please check your credentials.');
        }
    } catch (error) {
        toast.error('An error occurred. Please try again later.');
    }
};

// export const addToCart = (formData) => async (dispatch) => {
//     const isLoggedIn = localStorage.getItem('isLoggedIn');
//     if (isLoggedIn) {
//         try {

//             const response = await post(API_URL?.addToCart, formData);
//             if (response.isSuccess === 200) {
//                 dispatch({ type: ADD_TO_CART, payload: response.data });
//                 toast.success("Add item in cart Successful!");
//             } else {
//                 toast.error("Failed to add item to cart");
//             }
//         } catch (error) {
//             toast.error("An error occurred. Please try again.");
//         }
//     } else {
//         try {
//             const productDetails = await GetProductDetailById(formData.productId);

//             const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
//             const existingItem = localCartData.find(item => item.productId === productDetails.productId);

//             const sizeTypeName = localStorage.getItem('sizeTypeName') ||
//                 (productDetails?.productSkuDtos?.[0]?.sizeTypeName || null);

//             const shapeTypeName = localStorage.getItem('shapeTypeName') ||
//                 (productDetails?.productSkuDtos?.[0]?.colorName || null);

//             const weightTypeName = localStorage.getItem('weightTypeName') ||
//                 (productDetails?.productSkuDtos?.[0]?.colorName || null);

//             const skuId = localStorage.getItem('skuId') ||
//                 (productDetails?.productSkuDtos?.[0]?.skuId || null);
                

//             if (existingItem) {
//                 existingItem.quantity += 1;
//                 existingItem.shapeTypeName = shapeTypeName;
//                 existingItem.sizeTypeName = sizeTypeName;
//                 existingItem.weightTypeName = weightTypeName;
//                 existingItem.skuId = skuId;
//             } else {
//                 localCartData.push({ ...productDetails, quantity: 1,sizeTypeName: sizeTypeName, shapeTypeName: shapeTypeName ,weightTypeName: weightTypeName, skuId: skuId  });
//             }

//             localStorage.setItem('cart', JSON.stringify(localCartData));
//             dispatch({ type: ADD_TO_CART, payload: { ...productDetails, quantity: 1 ,sizeTypeName: sizeTypeName, shapeTypeName: shapeTypeName ,weightTypeName: weightTypeName, skuId: skuId} });
//         } catch (error) {
//             toast.error("Error occurred while fetching product details.");
//         }
//     }
// };



export const addToCart = (formData) => async (dispatch, getState) => {
    try {
        const { int: guestIdInt, raw: guestIp } = await getResolvedGuestId();
        const payload = {
            guest_id: String(guestIdInt || ""),
            ip_address: String(guestIp || ""),
            id: String(formData.id || ""),
            quantity: String(formData.quantity || 1),
            shape: String(formData.choice_2 || formData.shape || ""),
            size: String(formData.choice_1 || formData.size || ""),
            weight: String(formData.choice_3 || formData.weight || ""),
        };

        const response = await post(API_URL?.addToCart, payload);

        if (response?.status === 1 || response?.message === "Successfully added!") {
            dispatch({
                type: ADD_TO_CART,
                payload: {
                    cartItemId: response?.in_cart_key,
                    productId: response?.cart?.product_id,
                    displayName: response?.cart?.name || response?.cart?.product?.name || "",
                    quantity: response?.cart?.quantity,
                    unitPrice: response?.cart?.price,
                    currency_symbol: response?.cart?.currency_symbol || response?.cart?.product?.currency_symbol,
                    currencySymbol: response?.cart?.currency_symbol || response?.cart?.product?.currency_symbol,
                    currency_code: response?.cart?.currency_code || response?.cart?.product?.currency_code,
                    currencyCode: response?.cart?.currency_code || response?.cart?.product?.currency_code,
                    buyStatus: response?.cart?.is_checked,
                    sizeTypeName: response?.cart?.size || payload.size,
                    shapeTypeName: response?.cart?.shape || payload.shape,
                    weightTypeName: response?.cart?.weight || payload.weight,
                    slug: response?.cart?.slug,
                    thumbnail: response?.cart?.thumbnail,
                },
            });

            toast.success(response?.message || "Successfully added!");
            dispatch(get_cart_Data());
            return response;
        } else if (response?.status === 0 && response?.cart_id && response?.message === "Already added!") {
            const stateCart = getState?.()?.cartReducer?.cart || [];
            const existingCartItem = Array.isArray(stateCart)
                ? stateCart.find((item) =>
                    Number(item?.id || item?.cart_id || item?.cartItemId) === Number(response.cart_id) ||
                    Number(item?.product_id || item?.productId) === Number(formData.id)
                )
                : null;
            const previousQuantity = Number(existingCartItem?.quantity || 0);
            const nextQuantity = previousQuantity > 0
                ? previousQuantity + 1
                : Number(formData.quantity || 1);
            const updatePayload = {
                key: String(response.cart_id),
                cart_id: String(response.cart_id),
                guest_id: String(guestIdInt || ""),
                ip_address: String(guestIp || ""),
                id: String(formData.id || ""),
                quantity: String(nextQuantity),
                shape: payload.shape,
                size: payload.size,
                weight: payload.weight,
            };

            const updateResponse = await put(API_URL?.updateCart, updatePayload);

            toast.success("Cart quantity updated!");
            dispatch(get_cart_Data(guestIp));
            return updateResponse;
        } else {
            toast.error(response?.message || "Failed to add item to cart");
            throw new Error(response?.message || "Failed to add item to cart");
        }
    } catch (error) {
        toast.error(error?.response?.data?.message || "An error occurred. Please try again.");
        throw error;
    }
};

export const syncCartAfterLogin = () => async (dispatch) => {
    const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
    const isLoggedIn = localStorage.getItem('isLoggedIn');

    if (isLoggedIn && localCartData.length > 0) {
        try {
            const items = localCartData.map(item => ({
                skuId: item?.skuId || (item?.productSkuDtos?.length > 0 ? item.productSkuDtos[0]?.skuId : null),
                cartItemId: 0,
                productId: item.productId ? Number(item.productId) : 0,
                isLoggedIn: Number(isLoggedIn),
                buyStatus: 1,
                quantity: item.quantity,
                unitPrice: item.salePrice,
                totalAmount: item.salePrice,
                isActive: true,
                createdBy: 0,
                taxId: item.taxId || 0,
                taxAmount: item.taxAmount || 0
            }));

            const response = await post(API_URL?.SaveBulkCart, items);
            if (response.isSuccess === 200) {
                dispatch({ type: ADD_TO_CART_BULK, payload: response?.data });
                localStorage.removeItem('cart');
            } else {
                dispatch({ type: ADD_TO_CART_BULK, payload: [] });
            }
        } catch (error) {
            dispatch({ type: ADD_TO_CART_BULK, payload: [] });
        }
    } else {
    }
};

// export const incrQuantity = (item) => async (dispatch) => {
//     const isLoggedIn = localStorage.getItem('isLoggedIn');

//     if (isLoggedIn) {
//         const formData = {
//             skuId: item?.skuId,
//             productId: item.productId,
//             isLoggedIn: isLoggedIn,
//             buyStatus: 0,
//             quantity: item.quantity + 1,
//             isActive: true,
//             createdBy: 0
//         };

//         try {
//             const response = await post(API_URL?.SaveCartDetail, formData);
//             if (response.isSuccess === 200) {
//                 dispatch(get_cart_Data());
//             }
//         } catch (error) {

//         }
//     } else {
//         const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
//         const existingItem = localCartData.find(cartItem => cartItem.productId === item.productId);

//         if (existingItem) {
//             existingItem.quantity += 1;
//         } else {
//             localCartData.push({ ...item, quantity: 1 });
//         }

//         localStorage.setItem('cart', JSON.stringify(localCartData));
//         dispatch(get_cart_Data());
//     }
// };




// export const decrQuantity = (item) => async (dispatch, getState) => {
//     const isLoggedIn = localStorage.getItem('isLoggedIn');
//     if (isLoggedIn) {
//         const formData = {
//             skuId: item?.skuId,
//             productId: item.productId,
//             isLoggedIn: isLoggedIn,
//             buyStatus: 0,
//             quantity: item.quantity - 1,
//             isActive: true,
//             createdBy: 0
//         };

//         if (formData.quantity === 0 || formData.quantity === null) {
//             dispatch(deleteItem(item));
//             return;
//         }

//         try {
//             const response = await post(API_URL?.SaveCartDetail, formData);
//             if (response.isSuccess === 200) {
//                 dispatch(get_cart_Data());
//             }
//         } catch (error) {

//         }
//     } else {
//         const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
//         const existingItem = localCartData.find(cartItem => cartItem.productId === item.productId);

//         if (existingItem) {
//             existingItem.quantity -= 1;
//         }
//         else {
//             localCartData.push({ ...item, quantity: 1 });
//         }

//         localStorage.setItem('cart', JSON.stringify(localCartData));
//         dispatch(get_cart_Data());
//     }
// };


const updateCartQuantity = (item) => async (dispatch) => {
    const { int: guestIdInt, raw: guestIp } = await getResolvedGuestId();
    const ipAddress = item?.ip_address || item?.ipAddress || guestIp;
    const cartKey =
        item?.cart_id ||
        item?.cartItemId ||
        item?.id;

    if (!cartKey) {
        throw new Error("Cart item key is missing.");
    }

    const quantity = Number(item?.quantity || 1);

    if (quantity < 1) {
        throw new Error("Minimum quantity is 1");
    }

    const payload = {
        key: String(cartKey),
        cart_id: String(cartKey),
        guest_id: String(guestIdInt || ""),
        ip_address: String(ipAddress || ""),
        id: String(item?.product_id || item?.productId || ""),
        quantity: String(quantity),
        shape: String(item?.shape || item?.choice_2 || item?.shapeTypeName || ""),
        size: String(item?.size || item?.choice_1 || item?.sizeTypeName || ""),
        weight: String(item?.weight || item?.choice_3 || item?.weightTypeName || ""),
    };

    try {
        const response = await put(API_URL?.updateCart, payload);
        const isUpdated =
            response === "Successfully updated" ||
            response?.status === true ||
            response?.status === 1 ||
            response?.message ||
            response?.cart ||
            response?.data ||
            response?.id;

        if (isUpdated) {
            dispatch(get_cart_Data(ipAddress));
            return response;
        }

        throw new Error(response?.message || "Quantity update failed.");
    } catch (error) {
        throw new Error(error?.response?.data?.message || error?.message || "Quantity update failed.");
    }
};

export const incrQuantity = (item) => updateCartQuantity(item);

export const decrQuantity = (item) => updateCartQuantity(item);

// export const deleteItem = (item) => async (dispatch) => {
//     const isLoggedIn = localStorage.getItem('isLoggedIn');
//     if (isLoggedIn) {
//         try {
//             const response = await get(API_URL?.DeleteCartDetailByisLoggedIn, {
//                 pCartDetailId: item?.cartItemId,
//                 isLoggedIn: isLoggedIn
//             });

//             if (response.isSuccess === 200) {
//                 dispatch(get_cart_Data());
//             } else {
//                 toast.error("Failed to delete item");
//             }
//         } catch (error) {

//         }
//     } else {
//         const localCartData = JSON.parse(localStorage.getItem('cart')) || [];
//         const updatedCartData = localCartData.filter(cartItem => cartItem.productId !== item.productId);

//         localStorage.setItem('cart', JSON.stringify(updatedCartData));
//         dispatch(get_cart_Data());
//     }
// };



export const deleteItem = (item) => async (dispatch) => {
    const cartKey =
        item?.cart_id ||
        item?.cartItemId ||
        item?.id;

    try {
        const { int: guestIdInt } = await getResolvedGuestId();
        const ipAddress = item?.ip_address || item?.ipAddress || "";
        const response = await del(API_URL.removeCart, {
            data: {
                key: cartKey,
                guest_id: guestIdInt,
                ip_address: ipAddress,
            },
        });

        if (
            response === "Successfully removed" ||
            response?.message === "Successfully removed"
        ) {
            toast.success("Item removed successfully");
            dispatch(get_cart_Data(ipAddress));
        } else {
            toast.error(
                response?.message || "Failed to delete item"
            );
        }
    } catch (error) {
        toast.error(
            error?.response?.data?.message ||
            error?.response?.data?.errors?.[0]?.message ||
            "Something went wrong"
        );
    }
};

export const buyNow = (formData) => async (dispatch, getState) => {
    try {
        const { int: guestIdInt, raw: guestIp } = await getResolvedGuestId();
        const payload = {
            guest_id: String(guestIdInt || ""),
            ip_address: String(guestIp || ""),
            id: String(formData.id || ""),
            quantity: String(formData.quantity || 1),
            shape: String(formData.choice_2 || formData.shape || ""),
            size: String(formData.choice_1 || formData.size || ""),
            weight: String(formData.choice_3 || formData.weight || ""),
        };

        const response = await post(API_URL?.addToCart, payload);

        if (response?.status === 1 || response?.message === "Successfully added!") {
            const buyNowCartId =
                response?.cart_id ||
                response?.in_cart_key ||
                response?.data?.cart_id ||
                response?.data?.in_cart_key ||
                "";

            localStorage.removeItem('cartItemDetail');
            localStorage.removeItem('itemDetail');
            localStorage.setItem("buyNowCartKey", String(buyNowCartId));
            await dispatch(get_cart_Data());
            return response;
        }

        if (response?.status === 0 && response?.cart_id && response?.message === "Already added!") {
            const stateCart = getState?.()?.cartReducer?.cart || [];
            const existingCartItem = Array.isArray(stateCart)
                ? stateCart.find((item) =>
                    Number(item?.id || item?.cart_id || item?.cartItemId) === Number(response.cart_id) ||
                    Number(item?.product_id || item?.productId) === Number(formData.id)
                )
                : null;
            const previousQuantity = Number(existingCartItem?.quantity || 0);
            const nextQuantity = previousQuantity > 0
                ? previousQuantity + 1
                : Number(formData.quantity || 1);
            const updatePayload = {
                key: String(response.cart_id),
                cart_id: String(response.cart_id),
                guest_id: String(guestIdInt || ""),
                ip_address: String(guestIp || ""),
                id: String(formData.id || ""),
                quantity: String(nextQuantity),
                shape: payload.shape,
                size: payload.size,
                weight: payload.weight,
            };

            const updateResponse = await put(API_URL?.updateCart, updatePayload);

            localStorage.removeItem('cartItemDetail');
            localStorage.removeItem('itemDetail');
            localStorage.setItem("buyNowCartKey", String(response.cart_id));
            await dispatch(get_cart_Data(guestIp));
            return {
                ...updateResponse,
                status: updateResponse?.status ?? response.status,
                cart_id: response.cart_id,
                message: updateResponse?.message || response.message,
            };
        }

        throw new Error(response?.message || "Failed to add item to cart");
    } catch (error) {
        toast.error(error?.response?.data?.message || error?.message || "An error occurred. Please try again.");
        throw error;
    }
};

export const cartCheckout = (formData) => () => {
    const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];
    const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

    if (existingItemDetails.length > 0 || existingCartItemDetails.length > 0) {
        localStorage.removeItem('cartItemDetail');
        localStorage.removeItem('itemDetail');
    }
    localStorage.removeItem("buyNowCartKey");

    try {
        const nextCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];
        const filteredData = formData.filter(item => Number(item?.buyStatus) === 1);

        nextCartItemDetails.push(...filteredData);
        localStorage.setItem('cartItemDetail', JSON.stringify(nextCartItemDetails));
    } catch (error) {
        toast.error("An error occurred. Please try again.");
    }
}

export const productReorder = (formData) => () => {
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const existingItemDetails = JSON.parse(localStorage.getItem('itemDetail')) || [];
    const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

    if (existingItemDetails.length > 0 || existingCartItemDetails.length > 0) {
        localStorage.removeItem('cartItemDetail');
        localStorage.removeItem('itemDetail');
    }

    if (isLoggedIn) {
        try {
            const existingCartItemDetails = JSON.parse(localStorage.getItem('cartItemDetail')) || [];

            const filteredData = formData.filter(item => item.buyStatus === 1);

            // Add the new formData to the existing array
            existingCartItemDetails.push(...filteredData);

            // Store the updated array back into localStorage
            localStorage.setItem('cartItemDetail', JSON.stringify(existingCartItemDetails));

        } catch (error) {
            toast.error("An error occurred. Please try again.");
        }
    }
}

